import { render, staticRenderFns } from "./ShareForm.vue?vue&type=template&id=fc58da66&"
import script from "./ShareForm.vue?vue&type=script&lang=js&"
export * from "./ShareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports